import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type moment from 'moment-timezone';

import { TimeAgoBase } from './timeago';

@Pipe({
  name: 'rtTimeAgoAsync',
  pure: false,
  standalone: true,
})
export class TimeAgoAsyncPipe extends TimeAgoBase implements PipeTransform {
  public transform(
    value: moment.MomentInput,
    { omitSuffix, shortWithSuffix }: { omitSuffix: boolean; shortWithSuffix?: boolean } = {
      omitSuffix: false,
      shortWithSuffix: false,
    },
  ): string {
    if (!value) {
      return '';
    }

    return this.getTime(value, { omitSuffix, shortWithSuffix });
  }
}
